import * as R from "ramda";

import { CONCILIATED } from "../actions";

const findConciliatedIndex = (kukey, record) =>
  R.findIndex(
    element =>
      R.pathEq(["transfer", "kukey"], kukey)(element) &&
      R.pathEq(["transfer", "record"], record)(element)
  );

const defaultState = {
  loading: false,
  error: false,
  filters: [],
  pageIndex: 0
};

const fetch = state => ({ ...state, loading: true, error: false });
const fetchSuccess = (state, { payload }) => ({ ...state, loading: false, conciliated: payload });
const fetchError = state => ({ ...state, loading: false, error: true });

const getItems = (state, { payload: { kukey, record } }) => {
  const conciliatedCopy = [...state.conciliated];

  const index = findConciliatedIndex(kukey, record)(conciliatedCopy);

  const conciliatedElement = conciliatedCopy[index];

  conciliatedCopy[index] = { ...conciliatedElement, loading: true, error: false };

  return { ...state, conciliated: conciliatedCopy };
};

const getItemsSuccess = (state, { payload: { kukey, record, loadedItems } }) => {
  const conciliatedCopy = [...state.conciliated];
  const index = findConciliatedIndex(kukey, record)(conciliatedCopy);

  const conciliatedElement = conciliatedCopy[index];

  conciliatedCopy[index] = { ...conciliatedElement, loading: false, error: false, loadedItems };

  return { ...state, conciliated: conciliatedCopy };
};

const getItemsError = (state, { payload: { kukey, record } }) => {
  const conciliatedCopy = [...state.conciliated];
  const index = findConciliatedIndex(kukey, record)(conciliatedCopy);

  const conciliatedElement = conciliatedCopy[index];

  conciliatedCopy[index] = { ...conciliatedElement, loading: false, error: true };

  return { ...state, conciliated: conciliatedCopy };
};
const setFilters = (state, { payload }) => ({ ...state, filters: payload });
const setPageIndex = (state, { payload }) => ({ ...state, pageIndex: payload });

const ACTION_HANDLERS = {
  [CONCILIATED.FETCH]: fetch,
  [CONCILIATED.FETCH_SUCCESS]: fetchSuccess,
  [CONCILIATED.FETCH_ERROR]: fetchError,
  [CONCILIATED.GET_ITEMS]: getItems,
  [CONCILIATED.GET_ITEMS_SUCCESS]: getItemsSuccess,
  [CONCILIATED.GET_ITEMS_ERROR]: getItemsError,
  [CONCILIATED.SET_FILTER]: setFilters,
  [CONCILIATED.SET_PAGE_INDEX]: setPageIndex
};

// loadedItems, itemsError, itemsLoading

export default (state = defaultState, action) => {
  const handler = ACTION_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
};
